<div class="container">
    <div class="close">
        <button (click)="close()"><img src="assets/img/icons/close.svg" height="15"/></button>
    </div>
    <div class="parts-text">
        <h3>{{ 'Participation percentage to buy' | translate }}</h3>
        <span>There is {{ availablePercent }}% of asset available to buy</span>
    </div>
    <div class="amount-input">
        <input type="number" [min]="inputMin" [max]="inputMax" [step]="inputMin" (input)="onChangeAmount($event)">
        <p *ngIf="amount > 0">You are buying {{ buyPercent }}%</p>
        <p *ngIf="error.status" style="color: red">{{ error.message }}</p>
    </div>
    <div *ngIf="!error.status && amount > 0" class="buy" >
        <button (click)="close()">{{'Buy' | translate}}</button>
    </div>
</div>
